/* eslint-disable */
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import dayjs from "dayjs";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData } from "utils/Gateway";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import {
  getCalenderDateInString,
  getFullTextDateString,
} from "helper/EventHelper/EventHelper";

const SetupMeetingModal = ({
  token,
  personId,
  personName,
  setPersonName,
  setPersonId,
  setSelectedMeetingDate,
  setSelectedTimeSlot,
  selectedTimeSlot,
  setcomments,
  setmeetingReason,
}) => {
  const todayValue = new Date().toISOString().split("T")[0];

  const [dateValue, setDateValue] = useState(dayjs(todayValue));

  const [selectedMeetingDateText, setSelectedMeetingDateText] = useState("");

  const [timeSlotList, setTimeSlotList] = useState([
    {
      slot: "09:00",
      availability: false,
    },
    {
      slot: "10:00",
      availability: false,
    },
    {
      slot: "11:00",
      availability: false,
    },
    {
      slot: "12:00",
      availability: false,
    },
    {
      slot: "13:00",
      availability: false,
    },
    {
      slot: "14:00",
      availability: false,
    },
    {
      slot: "15:00",
      availability: false,
    },
    {
      slot: "16:00",
      availability: false,
    },
    {
      slot: "17:00",
      availability: false,
    },
    {
      slot: "18:00",
      availability: false,
    },
    {
      slot: "19:00",
      availability: false,
    },
    {
      slot: "20:00",
      availability: false,
    },
    {
      slot: "21:00",
      availability: false,
    },
  ]);

  const [selectedSlotIndex, setSelectedSlotIndex] = useState(null);

  //get all time slot
  const getAvailibiltyHandler = async (value) => {
    const meetingDateText = getFullTextDateString(value.$d);
    setSelectedMeetingDateText(meetingDateText);
    const selectedDate = getCalenderDateInString(value.$d);

    setSelectedMeetingDate(selectedDate);

    let requestUrl =
      url.API_BASE_URL +
      url.API_GET_MEMBER_TIMES_BY_DATE +
      `?token=${token}&memberid=${personId}&agendadate=${selectedDate}`;

    const response = await getData(requestUrl);

    //     console.log(response);

    if (response.status && response.data.length > 0) {
      setTimeSlotList(response.data);
    }
  };

  //slot select
  const slotSelectionHandler = (val, index) => {
    setSelectedSlotIndex(index);
    setSelectedTimeSlot(val.slot);
  };

  //meeting details modal
  const showMeetingDetailsModalhandler = () => {
    if (selectedTimeSlot != "") {
      let meetingModal = document.querySelector("#meeting_setup");
      let modal = bootstrap.Modal.getInstance(meetingModal);
      modal.hide();
      setSelectedSlotIndex(null);

      //show register modal
      let myModal = new bootstrap.Modal(
        document.getElementById("meeting_details")
      );
      myModal.show();
    }
  };

  const resetHandler = () => {
    if (setPersonName) {
      setPersonName("");
    }
    if (setPersonId) {
      setPersonId(null);
    }
    setSelectedMeetingDateText("");
    setSelectedSlotIndex(null);
    setSelectedMeetingDate("");
    setSelectedTimeSlot("");
    setmeetingReason("");
    setcomments("");
  };

  useEffect(() => {
    if (token && personId) {
      getAvailibiltyHandler(dayjs(todayValue));
    }
  }, [personId]);

  return (
    <div className="meet_modal">
      <div className="modal fade" id="meeting_setup" data-bs-backdrop="static">
        <div
          className="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body p-4">
              <div className="meet_date_outer d-flex flex-wrap">
                <div className="left_datepnl">
                  <h5 className="text-primary fs-sm fw-bold text-capitalize mb-2">
                    {personName}
                  </h5>
                  <h3 className="text-primary fs-xl text-uppercase mb-3">
                    60 Minute Meeting
                  </h3>
                  <h5 className="d-flex align-items-center gap-2 mb-2">
                    <i className="material-icons-outlined text-pink fs-sm">
                      schedule
                    </i>
                    <span className="fs-sm fw-bold text-primary">60 min</span>
                  </h5>
                </div>
                <div className="right_datepnl d-flex gap-2">
                  <div className="calender">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateCalendar
                        value={dateValue}
                        onChange={(value) => {
                          setDateValue(value);
                          getAvailibiltyHandler(value);
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="date_list">
                    <h4 className="text-black mb-4 fw-semibold fs-sm">
                      {selectedMeetingDateText}
                    </h4>
                    <ul className="list_style_none">
                      {timeSlotList.map((timeData, index) => {
                        return (
                          <li
                            className={`bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center ${
                              timeData.availability
                                ? "text-green"
                                : "text-danger"
                            } ${selectedSlotIndex == index ? "active" : ""}`}
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (timeData.availability) {
                                slotSelectionHandler(timeData, index);
                              }
                            }}
                          >
                            {timeData.slot}
                          </li>
                        );
                      })}
                    </ul>
                    {/* <ul className="list_style_none">
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        9:00am
                      </li>
                      <li className="active bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        9:30am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        10:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        10:30am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        11:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        9:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        9:30am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        10:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        10:30am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        11:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        9:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        9:30am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        10:00am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        10:30am
                      </li>
                      <li className="bg_white px-3 py-2 rounded-4 fs-sm fw-semibold mb-2 text-center">
                        11:00am
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer body_bg no-border px-4 pb-3">
              <div className="request_time_row d-flex align-items-center justify-content-between w-100">
                <Link
                  data-bs-dismiss="modal"
                  to="#"
                  className="btn"
                  onClick={resetHandler}
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  className="btn primary-btn"
                  onClick={showMeetingDetailsModalhandler}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupMeetingModal;
